// extracted by mini-css-extract-plugin
module.exports = {"imageLoader":"ImageLoader_imageLoader__2dNCR","loading":"ImageLoader_loading__2uwmJ","disabled":"ImageLoader_disabled__2V_xm","image":"ImageLoader_image__3eQR3"};